import { Alert, Snackbar, Stack } from "@mui/material";

export const SnackBar = (props) => {
  return (
    <>
      <Stack spacing={3} sx={{ width: "100%" }}>
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          autoHideDuration={5000}
          open={props.openError}
          onClose={props.handleClose}
        >
          <Alert severity="error">{props?.message} </Alert>
        </Snackbar>
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          autoHideDuration={5000}
          open={props.openSucess}
          onClose={props.handleClose}
        >
          <Alert severity="success">{props?.message} </Alert>
        </Snackbar>
      </Stack>
    </>
  );
};
